








/* Created- 25 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import { UserModel, AccountClient } from "../Generated/ParticaAPI";
import { ButtonConfig, ButtonType } from "../Models/Buttons";
import ParticaBaseView from "../Views/Base/ParticaBaseView.vue";
import RegistrationForm from "@/Ui-Components/Account/RegistrationForm.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import { eParticaAction, getActionName, ParticaEvent } from "../Models/ParticaEvent";
@Component(
	{
		name: "RegisterEmail",
		components: { ParticaError, RegistrationForm, ParticaRowContainer, ParticaCard }
	})
export default class RegisterEmail extends ParticaBaseView {
	private data: UserModel = new UserModel();
	private buttons: ButtonConfig[] = [
		{ label: "Register", action: eParticaAction.ACCOUNT_REGISTER, type: ButtonType.OK } as ButtonConfig,
	];

	private async eventHandler(event: ParticaEvent) {
		try {
			switch (event.action) {
				case eParticaAction.ACCOUNT_REGISTER: {
					const svc: AccountClient = new AccountClient();
					this.data.site = location.protocol + "//" + location.host;
					await svc.register(this.data);
					this.ShowSnackbar("Check you email for the verification link we sent.");
					break;
				}
				case eParticaAction.ACCOUNT_FORGOTTEN_PASSWORD: {
					throw new Error("Not implemented");
					// break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		}
	}
}
